/**
 * Day/dark mode switch for the header button [data-theme-toggle].
 * Sets data-theme="dark" on <html> (colors live in config/styles.css) and
 * stores the choice in localStorage so it persists across pages.
 * An inline script in the head applies the saved choice before first paint.
 */
const root = document.documentElement;
const KEY = 'kreo-theme';

const sync = () => {
  const dark = root.getAttribute('data-theme') === 'dark';
  for (const button of document.querySelectorAll('[data-theme-toggle]')) {
    button.setAttribute('aria-pressed', String(dark));
    button.setAttribute('aria-label', dark ? button.dataset.labelLight : button.dataset.labelDark);
  }
};

const apply = (dark) => {
  if (dark) root.setAttribute('data-theme', 'dark');
  else root.removeAttribute('data-theme');
  try { localStorage.setItem(KEY, dark ? 'dark' : 'light'); } catch (e) { /* storage unavailable */ }
  sync();
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-theme-toggle]');
  if (!button) return;
  const nextDark = root.getAttribute('data-theme') !== 'dark';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // A short crossfade between modes where the browser supports it.
  if (document.startViewTransition && !reduce) document.startViewTransition(() => apply(nextDark));
  else apply(nextDark);
});

sync();
